import { Component } from '@angular/core';
import { ApiProviderService } from '../../data/services/api/api-provider.service';
import { ActivatedRoute } from '@angular/router';
import { ASSETS_COLUMNS } from '../../data/constants/provider.constants';
import { ApiAssetsService } from '../../data/services/api/api-assets.service';

@Component({
  selector: 'app-provider-detail',
  templateUrl: './provider-detail.component.html',
  styleUrls: ['./provider-detail.component.scss']
})
export class ProviderDetailComponent {
  id!: string;
  provider!: any;
  assets: any[] = [];
  assetsColumns = ASSETS_COLUMNS

  constructor(
    public apiProviderService: ApiProviderService,
    private activatedRoute: ActivatedRoute,
    public apiAssetService: ApiAssetsService
  ) {
    this.id = this.activatedRoute.snapshot.paramMap.get('id') ?? '';
    this.apiAssetService.id = this.id;
    this.getProviderData();
    this.getProviderAssets(this.id);
  }

  getProviderData() {
    this.apiProviderService.getById(this.id).subscribe((response) => {
      if (!response.error) {
        this.provider = response.data;
      } else {
        console.error(response.msg);
      }
    });
  }

  getProviderAssets(id: string) {
    this.apiProviderService.getAssetsFromProvider(id).subscribe((response) => {
      if (!response.error) {
        this.assets = response.data;
      } else {
        console.error(response.msg);
      }
    })
  }
}
